import { useAppSelector } from "store";

const LoginLogo = () => {
    const logoUrl = useAppSelector((state: any) => state.config.instance.logoUrl) as string;
    return <img src={logoUrl} alt="Logo" className="loginLogo" />;
}

export default LoginLogo;